import React from "react";

import ShipeeziGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { colors } from "@zapalacorp/tokens";
import { IconMaterial } from "Components/Generic/Icons/IconMaterial";
import { useTranslation } from "react-i18next";

import { IconAirFreight } from "../../../../../../../components/Generic/Icons/IconAirFreight";
import { IconNotGoing } from "../../../../../../../components/Generic/Icons/IconNotGoing";
import { IconRoadFreight } from "../../../../../../../components/Generic/Icons/IconRoadFreight";
import { IconSeaFreight } from "../../../../../../../components/Generic/Icons/IconSeaFreight";
import {
  ItemJobCustomerPortal,
  MaterialCustomerPortal,
} from "../../../../../../../models/customer.portal";
import { Destination } from "../../../../../../../models/destination";
import { Location } from "../../../../../../../models/location";
import { DESTINATION, Mode, MODE } from "../../../../../../../util/enums";
import useStyles, { ModeIconColumn, SubGridContainer } from "./styles";

interface AfterRoomRowProps {
  roomItemsJobs: ItemJobCustomerPortal[];
  roomMaterials: MaterialCustomerPortal[];
}

export const AfterRoomRow = ({ roomItemsJobs, roomMaterials }: AfterRoomRowProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const getIconByModeOrDestination = (
    mode?: MODE | string,
    destination?: Destination,
    destinationResidence?: Location
  ) => {
    if (destination) {
      const destinationName = destination?.name;

      switch (destinationName?.toLowerCase()) {
        case DESTINATION.NOT_GOING.toLowerCase():
          return <IconNotGoing width={20} height={20} color={colors.error600} />;
        case DESTINATION.AIR.toLowerCase():
          return <IconAirFreight width={20} height={20} color={colors.indigo600} />;
        case DESTINATION.SEA.toLowerCase():
          return <IconSeaFreight width={20} height={20} color={colors.blue600} />;
        case DESTINATION.ROAD.toLocaleLowerCase():
          return <IconRoadFreight width={20} height={20} color={colors.orange800} />;
        default:
          return;
      }
    }
    if (mode) {
      switch (mode?.toLowerCase()) {
        case Mode.Road.toLowerCase():
          return <IconRoadFreight width={20} height={20} color={colors.orange800} />;
        case Mode.Air.toLowerCase():
          return <IconAirFreight width={20} height={20} color={colors.indigo600} />;
        case Mode.Sea.toLowerCase():
          return <IconSeaFreight width={20} height={20} color={colors.blue600} />;
        default:
          return null;
      }
    }

    if (destinationResidence) {
      return <IconRoadFreight width={20} height={20} color={colors.orange800} />;
    }

    return null;
  };

  const itemsColumns: Column[] = [
    {
      name: "mode",
      title: "",
      className: classes.icon,
      formatComponent: (_, row: ItemJobCustomerPortal) => (
        <ModeIconColumn>
          {getIconByModeOrDestination(row?.mode, row?.destination, row?.destinationResidence)}
        </ModeIconColumn>
      ),
    },
    { name: "description", title: translate("item"), className: classes.item },
    { name: "quantity", title: translate("quantity"), className: classes.quantity },
  ];

  const materialColumns: Column[] = [
    {
      name: "mode",
      title: "",
      className: classes.icon,
      formatComponent: () => <IconMaterial width={20} height={20} color={colors.gray600} />,
    },
    {
      name: "serviceBooking",
      title: translate("material"),
      className: classes.item,
      formatComponent: (value) => value?.name || "",
    },
    { name: "quantity", title: translate("quantity"), className: classes.quantity },
  ];

  return (
    <SubGridContainer>
      <ShipeeziGrid
        data={roomItemsJobs}
        columns={itemsColumns}
        showSelection={false}
        showHeaderGrid={false}
        showFooterGrid={false}
        showColumnChooser={false}
      />
      <ShipeeziGrid
        data={roomMaterials}
        columns={materialColumns}
        showSelection={false}
        showHeaderGrid={false}
        showFooterGrid={false}
        showColumnChooser={false}
      />
    </SubGridContainer>
  );
};
